module.exports = __webpack_public_path__ + "asset/image-logo-104bccce90ff48d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/logo/image/logo.svg
// module id = gTjh
// module chunks = 3